import React, {useEffect, useState, useRef, ReactNode, useMemo, useCallback} from 'react';
import { DatePicker, Button, Modal, Radio, Space, Form, Select,Table,  message, Popconfirm,Pagination, Tooltip } from 'antd';
import moment, { Moment } from 'moment';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';
import SPContentWrap from "components/carRental/base/SPContentWrap";
import { CrossTable  } from 'ali-react-table/pivot'
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import {ModeTypeSetObj, ModeType, COL_WIDTH, MIN_WIDTH, getBgColor, borderColorObj, DEFAULT_DAY} from './const'
import MyCrossTable from './MyCrossTable';
import { VerticalAlignTopOutlined  } from '@ant-design/icons';
import emiter, {
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH,
  EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN,
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH,
  _EVENTS, EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE
} from '../../../../events';

import { _APIS } from 'apis';
import request from 'request';
import {
	API_VEHICLE_OCCUPY_LIST,
	API_VEHICLE_OCCUPY_RELEASE,
	API_STORE_LIST_SELECT,
} from '../../../../hooks/carRental/_';
import {allowPermission} from "../../../../utils/permission";
const { confirm } = Modal;



interface SPOccupyCalendarProps {
	enums?: any;
	permission?: any;
}


const SPOccupyCalendar: React.FC<SPOccupyCalendarProps> = props => {
	const { enums, permission } = props;
  const [showMode, setShowMode] = useState<ModeType>(ModeType.DAY);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreen = () => {
    const element:any = document.body;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) { // Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) { // Chrome, Safari, Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) { // IE/Edge
      element.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const handleExitFullScreen = () => {
    const doc: any = document
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) { // Firefox
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) { // Chrome, Safari, Opera
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) { // IE/Edge
      doc.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

	const [dateRange, setDateRange] = useState<any>({
		start_date: moment(),
		end_date: moment().add(DEFAULT_DAY, 'days'),
	});
	const [data, setData] = useState<any>([]);
	const [columns, setColumns] = useState<any>([]);
	const [storeCode, setStoreCode] = useState<any>();

	const getStoreCode = () => {
		request({
			url: API_STORE_LIST_SELECT,
			method: 'GET',
		}).then((res: any) => {
			if (!res.data || !res.data.length) {
				return;
			}
			delete res.data[0].store_name;
			loadData(res.data[0]);
		});
	};

	const loadData = (data?: any) => {
		request({
			url: API_VEHICLE_OCCUPY_LIST,
			method: 'GET',
			params: {
				encrypt_veh_plate: data?.veh_plate
					? encryptTextByAES(data.veh_plate)
					:  undefined,
				store_code: data.store_code,
				vehicle_id:
					data && data.vehicle_id && data.vehicle_id.length === 3
						? data.vehicle_id[2]
						: undefined,
			},
		}).then((res: any) => {
			if (data.date?.[0] && data.date?.[1]) {
				setDateRange({
					start_date: moment(data.date[0]).startOf('day'),
					end_date: moment(data.date[1]).endOf('day'),
				});
			} else {
				setDateRange({
					start_date: moment().startOf('day'),
					end_date: moment().add(DEFAULT_DAY, 'days').endOf('day'),
				});
			}
			if (res.data.list && res.data.list.length) {
				res.data.list.forEach((item: any) => {
					if (item.occupy && item.occupy.length) {
						item.occupy.forEach((every: any) => {
							if (every.encrypt_veh_plate) {
								every.encrypt_veh_plate = decryptTextByAES(every.encrypt_veh_plate);
							}
						});
					}
				});
				setData(res.data.list);
				setStoreCode(data.store_code);
			} else {
				setData([]);
			}
		});
	};

  useEffect(() => {
    emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE, showMode);
  }, [showMode]);

  const tipText = useMemo(() => {
    const startDate = dateRange.start_date;
    const endDate = dateRange.end_date;
    const daysDifference = endDate.diff(startDate, 'days') + 1;
    if (daysDifference > ModeTypeSetObj[showMode]?.maxDay) {
      return ` ${ModeTypeSetObj[showMode]?.exceedText}`
    }
    return ''
  },[showMode, dateRange])

  const annotation = useMemo(() => {
    return <span>注：点击空白处可进行占库操作，点击色块可查看库存占用情况<span style={{color: '#ff6400'}}>{tipText}</span></span>
  }, [tipText])


  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH, loadData);
		getStoreCode();
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH)
		}
	}, []);

  const leftTree = useMemo(()=> data.map((item: any) => {
    return  {
      key: `${item.brand_id}${item.series_id}${item.vehicle_id}`,
      width: COL_WIDTH,
      fixed: true,
      title: <Tooltip title={`${item.brand_name} · ${item.series_name} ·  ${item.vehicle_name}`}>
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {`${item.brand_name}${item.series_name}${item.vehicle_name}`}
        </div>
      </Tooltip>,
      data: item,
      children: item.occupy.map((i: any) => {
        return {
          width: COL_WIDTH,
          key: i.veh_code,
          fixed: true,
          title: <Tooltip title={i.status === 1 ? '已下架' : '已上架'}>
            <div style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: i.status === 1 ? 'rgba(0, 0, 0, 0.45)' : 'inherit'
            }}>
              {i.encrypt_veh_plate}
            </div>
          </Tooltip>,
          data: {
            ...item,
            ...i
          }
        }
      }),
    }
  }), [data])

  const fomateDay = (momentDay: any) => {
    const weekdaysShort = ['日', '一', '二', '三', '四', '五', '六'];
    const date = moment(momentDay);  // 示例日期
    const formattedDate = date.format('MM/DD') + ' ' + weekdaysShort[date.day()];
    return formattedDate;
  }

  const getDayArr = (startDay: any, endDay: any, length: number) => {
    let startVal = moment(startDay).startOf('day');
    let dayArr = []
    while (startVal.isBefore(moment(endDay).endOf('day'))) {
      dayArr.push({
        title: fomateDay(startVal),
        value: startVal.format('YYYY-MM-DD'),
        start: moment(startVal).startOf('day'),
        end: moment(startVal).endOf('day'),
        modeType: ModeType.DAY
      })
      if (dayArr.length > length) {
        break
      }
      startVal = startVal.add(1, 'day')
    }
    return dayArr
  }

  const getWeekArr = (startTime: any, endTime: any, length: number) => {
    const arr = [];
    let start = moment(startTime).startOf('week'); // 将开始时间补全到当前周的开始时间
    const end = moment(endTime);   // 将结束时间转为 moment 对象

    while (start.isBefore(end)) {
      // 当前周的结束时间，限制在 end 之前
      let weekEnd = moment.min(start.clone().endOf('week'), end);

      // 如果这不是完整的一周，补全到一周的结束时间
      if (weekEnd.isBefore(start.clone().endOf('week'))) {
        weekEnd = start.clone().endOf('week');
      }

      // 将当前周的开始时间和结束时间存入数组
      arr.push({
        start: start.clone().format('YYYY-MM-DD HH:mm:ss'),
        end: weekEnd.format('YYYY-MM-DD HH:mm:ss')
      });
      if (arr.length > length) {
        break
      }

      // 将开始时间移到下周的开始
      start = weekEnd.add(1, 'second').startOf('week');
    }

    return arr;
  }

  const topTree: any[] = useMemo(() => {
    if ( ModeType.DAY === showMode) {
      return getDayArr(dateRange.start_date, dateRange.end_date, ModeTypeSetObj[showMode]?.maxDay)?.map((item: any) => {
        return {
          key: item.value,
          title: item.title,
          data: item,
          width: COL_WIDTH,
          modeType: ModeType.DAY,
        }
      }) || []
    } else if (ModeType.HOUR === showMode) {
      return getDayArr(dateRange.start_date, dateRange.end_date, ModeTypeSetObj[showMode]?.maxDay)?.map((item: any) => {
        return {
          key: item.value,
          title: item.title,
          data: item,
          children: new Array(24).fill(1).map((i, j) => {
            return {
              key: j,
              title: `${j}点`,
              modeType: ModeType.HOUR,
              width: COL_WIDTH,
              data: {
                date: item.value,
                modeType: ModeType.HOUR,
                hour: j,
                start: `${item.value} ${('0' + j).slice(-2)}:00:00`,
                end: `${item.value} ${('0' + j).slice(-2)}:59:59`,
                value: `${item.value} ${('0' + j).slice(-2)}:00:00`
              }
            }
          })
        }
      }) || []
    } else if (ModeType.WEEK === showMode) {
      return getWeekArr(dateRange.start_date, dateRange.end_date, ModeTypeSetObj[showMode]?.maxWeek)?.map((item: any) => {
        return {
          key: item.start,
          width: COL_WIDTH,
          modeType: ModeType.WEEK,
          title: <>
            <div>{item?.start?.slice(5, 10)}</div>
            <div style={{lineHeight: '10px'}}>-</div>
            <div>{item?.end?.slice(5, 10)}</div>
          </>,
          data: {
            modeType: ModeType.WEEK,
            ...item
          }
        }
      })
    }
    return []
  }, [dateRange, showMode])

  const onChangeMode = (e: any) => {
    setShowMode(e.target.value)
    resetScroll()
  }

  const resetScroll = (e?: any) => {
    const tableElement = document.querySelector('.art-horizontal-scroll-container');
    if (tableElement) {
      tableElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    e?.currentTarget?.blur();
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const doc = document as any
      if (!document.fullscreenElement && !doc.webkitFullscreenElement && !doc.mozFullScreenElement && !doc.msFullscreenElement) {
        console.log('Exited fullscreen');
        setIsFullScreen(false)
        // 在这里可以执行退出全屏后的其他操作
      } else {
        setIsFullScreen(true)
        console.log('Entered fullscreen');
      }
    };

    // 监听不同浏览器的 fullscreenchange 事件
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
    document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
    document.addEventListener('MSFullscreenChange', handleFullscreenChange); // Internet Explorer/Edge

    // 清理事件监听器
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);


  return (
		<div style={{ backgroundColor: '#fff', padding: '10px'}}>
			<div style={{ display: 'flex', justifyContent: 'space-between',alignItems: 'center', margin: '0 0 10px' }}>
				<Space>
					{enums.stock_use_type?.map((item: any) => {
						return (
              <Space style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div
                  style={{
                    height: 16,
                    width: 16,
                    boxSizing: 'border-box',
                    background: getBgColor(item.key),
                    borderRadius: '3px',
                  }}
                >
                </div>
                <div style={{
                  color: 'rgba(0, 0, 0, 0.88)',
                  lineHeight: '22px',
                  fontSize: '14px',
                }}>
                  {item.value}
                </div>
              </Space>

            );
          })}
          <div style={{
            fontSize: '12px',
            lineHeight: '20px',
            color: '#666666',
          }}>{annotation}</div>

        </Space>
        <Space>
          <Button size='middle' icon={!isFullScreen ? <FullscreenOutlined/> : <FullscreenExitOutlined/>}
                  onClick={(e) => {
                    e.currentTarget.blur();
                    if (!isFullScreen) {
              handleFullScreen()
            } else {
              handleExitFullScreen()
            }
          }}>{!isFullScreen ? '全屏' : '退出全屏' }</Button>
          <Button style={{ transform: 'rotate(-90deg)' }} size='middle' icon={<VerticalAlignTopOutlined />} onClick={resetScroll}>

          </Button>
          <Radio.Group size='middle' buttonStyle="solid" onChange={onChangeMode} value={showMode}>
            <Radio.Button style={{ borderRadius: '6px 0 0 6px' }} value={ModeType.HOUR}>时</Radio.Button>
            <Radio.Button  value={ModeType.DAY}>日</Radio.Button>
            <Radio.Button style={{ borderRadius: '0 6px 6px 0' }} value={ModeType.WEEK}>周</Radio.Button>
          </Radio.Group>
        </Space>
			</div>
      <MyCrossTable
        permission={permission}
        store_code={storeCode}
        leftTree={leftTree}
        dateRange={dateRange}
        topTree={topTree}
      ></MyCrossTable>
    </div>
  );
};

export default SPOccupyCalendar;
